import { connect } from 'react-redux';
import storage from '../../../../../lib/Storage';

import LearningAdminModuleCard from '../components/LearningAdminModuleCard';
import Format from '../../../../../lib/Format';
import {
  getImageSignedURL,
  setActiveImage,
} from '../../../../../state/modules/media/actions';
import { moduleAdminShowPreviewDetail } from '../../../../../state/modules/learningsAdmin/actions';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  const coverImage = ownProps.item?.cover_image ?? null;
  const sizeWidth = 329;
  const sizeHeight = 159;

  const imagePath = Format.buildImagePath(
    'ratio',
    sizeWidth,
    sizeHeight,
    coverImage
  );
  const imageUrl = state.media.getIn(['images', imagePath]) ?? null;

  return {
    imagePath: imagePath,
    imageUrl: imageUrl,
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSignedUrl: (path, cb) => {
      dispatch(getImageSignedURL(path, cb));
    },
    setActiveImage: (imageUrl, imagePath) => {
      dispatch(setActiveImage(imageUrl, imagePath));
    },
    showDetail: (id) => {
      dispatch(moduleAdminShowPreviewDetail(id));
    },
  };
};

const LearningAdminModuleCardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleCard);

export default LearningAdminModuleCardContainer;
